import { render, staticRenderFns } from "./FlowManageDetail.vue?vue&type=template&id=436a6d12&scoped=true"
import script from "./FlowManageDetail.vue?vue&type=script&lang=js"
export * from "./FlowManageDetail.vue?vue&type=script&lang=js"
import style0 from "./FlowManageDetail.vue?vue&type=style&index=0&id=436a6d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a6d12",
  null
  
)

export default component.exports